import Text from '../../core/utils/Text'
import { Body, Title, Header } from '../../styles/layout-styles/CardLayoutStyles'

const CardLayout = (props) => {
	const {
		width,
		height,
		title = null,
		icon,
		children,
		minHeight,
		maxHeight,
		marginTop,
		styleProps = {},
		className,
		...rest
	} = props

	return (
		<Body
			className={`${className}`}
			width={width}
			height={height}
			minHeight={minHeight}
			maxHeight={maxHeight}
			marginTop={marginTop}
			{...styleProps}
			{...rest}
		>
			{title && (
				<Header title={title}>
					<Title>
						<Text tid={title} className='text-2xl' />
					</Title>
					{icon && icon}
				</Header>
			)}
			{children}
		</Body>
	)
}

export default CardLayout
